/**
=========================================================
* Soft UI Dashboard React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";

import { useMsal } from '@azure/msal-react';

// Images
import feiFull from "assets/images/fei-bg.png";

// Authentication layout components
import BasicLayout from "layouts/login/components/BasicLayout";
import brand from "assets/images/logos/FEI logo-21-inv-trn.png";
import userLines from "assets/images/user_lines.png";


function Login() {

    const { instance, accounts } = useMsal();

    const signin = () => {
        instance.loginPopup({}).catch(err => {
            console.error(err.message);
        })
    }

    return (
        <BasicLayout
        title={<img src={brand} height={100} alt="person" />}
        description="FEI Logistics"
        image={feiFull}
        >
        <Card style={{minHeight: 300}}>
            <SoftBox pt={2} mb={1} textAlign="center">                
                <img src={userLines} height={100} alt="person" />
            </SoftBox>
            <SoftBox pt={0} pb={3} px={3}>
            <SoftButton fullWidth onClick={signin} color="primary">Sign In</SoftButton>
            </SoftBox>
        </Card>
        </BasicLayout>
       
    );
}

export default Login;
